export default __webpack_public_path__ + "7e661c7c640627fb9997b9bb6462c6ef.gif";